(function() { module.exports = this["wp"]["components"]; }());